import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes.js'
import { authGuard, falseRoute, fetchLoggedUserGuard, showCountdownTimer } from '@/routerGuards'

Vue.use(Router)

const instance = new Router({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    }
    return { x: 0, y: 0 }
  }
})

instance.beforeEach(showCountdownTimer)

instance.beforeEach(fetchLoggedUserGuard)
instance.beforeEach(async (to, from, next) => {
  return await authGuard(to) ? next() : next(falseRoute(from))
})

export default instance
